<dialog id="confirmation_dialog" class="modal text-slate-50" [open]="dialogOpen()">
  <div class="flex flex-col gap-y-4 items-center w-[33vw] max-w-[33vw] bg-base-100/5 backdrop-blur-md 
           shadow-xl rounded
           border border-base-100/15   px-8 py-8 relative">
    <span class="material-symbols-outlined md-64 text-[64px]!">exit_to_app</span>
    <h3 class="text-2xl mb-4 lg:mb-8">{{ action() | titlecase }}</h3>
    <span class="text-xs"> Are you sure you want to {{ action() }}? </span>
    <div class="flex flex-row items-center justify-around gap-x-4">
      <button (click)="onConfirm()"
        class="rounded  border-0 bg-primary/50 backdrop-blur-md py-1 px-3 text-xs text-base-100/90 hover:bg-opacity-85 focus:outline-none">
        Confirm
      </button>
      <button (click)="onCancel()"
        class="rounded  border-0 bg-accent/50 backdrop-blur-md py-1 px-3 text-xs text-base-100/90 hover:bg-opacity-85 focus:outline-none">
        Cancel
      </button>
    </div>
    <form method="dialog">
      <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" (click)="onCancel()">
        ✕
      </button>
    </form>
  </div>
</dialog>